import { useEffect } from "react";
import ReactDOM from "react-dom";
import { useWishlist } from "../../Context/WishlistContext";

const DeletePromptForCart = ({ showModal, onDelete, onCancel, data }) => {
  const {
    wishlist: wishlistItems,
    addToWishlist,
    removeFromWishlist,
  } = useWishlist();

  useEffect(() => {
    if (showModal) document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  if (!showModal) return null;
  const isWishlisted = data
    ? wishlistItems.some(
        (w) =>
          w.product_id === data.product_id && w.variant_id === data.variant_id,
      )
    : false;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center p-4 font-poppins bg-black/30 backdrop-blur-sm"
      style={{ zIndex: 99999, animation: "dpFadeIn 0.18s ease" }}
      onClick={onCancel}
    >
      <div
        className="relative w-full max-w-[22rem] rounded-2xl overflow-hidden bg-[#0e1e1c] border border-[#1e4a46] shadow-2xl"
        style={{ animation: "dpModalIn 0.24s cubic-bezier(0.16,1,0.3,1)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top accent */}
        <div className="h-[3px] w-full bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />

        <div className="px-7 py-7">
          {/* Product preview */}
          {data && (
            <div className="flex items-center gap-3.5 rounded-xl p-3.5 mb-5 bg-[#162c2a] border border-[#1e4a46]">
              <div className="w-[60px] h-[60px] rounded-[10px] flex-shrink-0 overflow-hidden bg-[#0c1c1a] border border-[#1e4a46] flex items-center justify-center">
                <img
                  src={data.image}
                  alt={data.name}
                  className="w-full h-full object-contain p-1"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/default.svg";
                  }}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p
                  className="text-[0.82rem] font-bold text-white leading-snug line-clamp-2 mb-1"
                  style={{ fontFamily: "'Nunito',sans-serif" }}
                >
                  {data.name}
                </p>
                {/* {data.manufacturer && (
                  <p className="text-[0.7rem] text-[#5fbdb3] truncate mb-1">
                    {data.manufacturer}{data.pack_size ? ` · ${data.pack_size}` : ""}
                  </p>
                )} */}
                <div className="flex items-center gap-1.5 flex-wrap">
                  {data.mrp && data.discount_percent > 0 ? (
                    <>
                      <span className="text-[0.7rem] line-through text-[#4a8a85]">
                        ₹{data.mrp}
                      </span>
                      <span className="text-[0.82rem] font-bold text-[#ff8050]">
                        ₹{data.discounted_price}
                      </span>
                      <span className="text-[0.62rem] font-bold px-1.5 py-0.5 rounded-full bg-[#ff601e]/15 text-[#ff8050]">
                        {data.discount_percent}% OFF
                      </span>
                    </>
                  ) : (
                    <span className="text-[0.82rem] font-bold text-white">
                      ₹{data.mrp || data.discounted_price}
                    </span>
                  )}
                </div>
                {data.quantity && (
                  <p className="text-[0.68rem] text-[#3a7a75] mt-0.5">
                    Qty: {data.quantity}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* Heading */}
          <h2
            className="text-center text-[1.05rem] font-bold text-white mb-1.5 tracking-tight"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            Remove from cart?
          </h2>
          <p className="text-center text-[0.85rem] font-medium text-[#7abcb8] mb-5 leading-relaxed">
            Save it to your wishlist before removing.
          </p>

          {/* Move to wishlist */}
          {data && (
            <button
              onClick={() => {
                if (isWishlisted)
                  removeFromWishlist(data.product_id, data.variant_id);
                else addToWishlist(data, data);
              }}
              className={`w-full rounded-xl py-2.5 mb-3 text-[0.82rem] font-bold uppercase tracking-wider cursor-pointer transition-all
                ${
                  isWishlisted
                    ? "bg-red-500/10 text-red-400 border border-red-500/25 hover:bg-red-500/20"
                    : "bg-[#5fbdb3]/10 text-[#5fbdb3] border border-[#5fbdb3]/28 hover:bg-[#5fbdb3]/20"
                }`}
            >
              {isWishlisted ? "✕ Remove from Wishlist" : "♡ Move to Wishlist"}
            </button>
          )}

          {/* Cancel + Delete */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 rounded-xl border border-[#1e4a46] bg-transparent py-3 text-[0.88rem] font-semibold text-[#7abcb8] cursor-pointer transition-all hover:border-[#5fbdb3] hover:text-white"
            >
              Cancel
            </button>
            <button
              onClick={onDelete}
              className="flex-1 rounded-xl border-none bg-red-500 hover:bg-red-600 py-3 text-[0.88rem] font-extrabold uppercase tracking-widest text-white cursor-pointer transition-all shadow-[0_4px_14px_rgba(239,68,68,0.4)]"
              style={{ fontFamily: "'Nunito',sans-serif" }}
            >
              Delete
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes dpFadeIn  { from { opacity:0; } to { opacity:1; } }
        @keyframes dpModalIn { from { opacity:0; transform:translateY(22px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
      `}</style>
    </div>,
    document.body,
  );
};

export default DeletePromptForCart;
